import { render, staticRenderFns } from "./expander-content.vue?vue&type=template&id=c0828952"
import script from "./expander-content.vue?vue&type=script&lang=js"
export * from "./expander-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports